import { useEffect, useState } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  OutlinedInput,
  CircularProgress,
} from "@mui/material";
import { changeSessionTenant } from "../../api/APIHelpers";
import { extractApiErrorMessage } from "../helpers/ErrorUtils";
import { sortBy } from "lodash";

const SelectTenant = ({ tenantInfo, setInfoMessages }) => {
  const [selectedTenant, setSelectedTenant] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Initialize and update selectedTenant when tenantInfo changes
  useEffect(() => {
    if (tenantInfo?.currentTenantId) {
      setSelectedTenant(tenantInfo.currentTenantId);
    }
  }, [tenantInfo?.currentTenantId]);

  const handleTenantChange = async (newTenantId) => {
    try {
      setIsLoading(true);
      await changeSessionTenant(newTenantId);
      setSelectedTenant(newTenantId);
      window.location.reload(true);
    } catch (error) {
      console.error("Failed to change tenant:", error);
      setInfoMessages({
        type: "snackbar",
        message: `Failed to change tenant: ${extractApiErrorMessage(error)}`,
        severity: "error",
        open: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <FormControl sx={{ width: 200 }}>
        <InputLabel id='tenant-label'>Tenant</InputLabel>
        <Select
          labelId='tenant-label'
          value={selectedTenant}
          onChange={(e) => handleTenantChange(e.target.value)}
          size={"small"}
          input={<OutlinedInput label='Tenant' />}
          disabled={isLoading}
          endAdornment={isLoading ? <CircularProgress size={20} /> : null}>
          {tenantInfo?.availableTenants &&
            sortBy(tenantInfo.availableTenants, (tenant) => {
              return tenant.DisplayName;
            }).map((tenant, index) => {
              return (
                <MenuItem key={index} value={tenant.TenantId}>
                  {tenant.DisplayName}
                </MenuItem>
              );
            })}
          {!tenantInfo?.availableTenants && (
            <MenuItem value={""}>None</MenuItem>
          )}
        </Select>
      </FormControl>
    </>
  );
};

export default SelectTenant;
